import api from './api';
import { unwrapList } from './unwrapList';

export interface Module {
  id: number;
  slug: string;
  name: string;
  description: string;
  status: 'active' | 'development' | 'maintenance' | 'hidden';
  group: string;
  icon: string;
  route: string;
  sortOrder: number;
  requiresPlan: string | null;
}

export const moduleService = {
  getActiveModules: async (): Promise<Module[]> => {
    const response = await api.get<{ data: Module[] }>('/modules');
    const modules = response.data?.data ?? response.data;
    console.log('[moduleService] raw response.data:', response.data);
    console.log('[moduleService] resolved modules:', Array.isArray(modules) ? modules.length : typeof modules);
    return Array.isArray(modules) ? modules : [];
  },

  getAllModules: async (): Promise<Module[]> => {
    const response = await api.get<{ data: Module[] }>('/admin/modules');
    return unwrapList<Module>(response.data);
  },

  updateStatus: async (slug: string, status: Module['status']): Promise<void> => {
    await api.patch(`/admin/modules/${slug}/status`, { status });
  },
};
